import {
	action,
	autorun,
	observable,
	makeObservable,
	computed,
	runInAction,
} from 'mobx';
import {enumToValues} from '@netx/core-next/utils/enum';
import {RuleModel} from '../baseModel';
import {CategoryType, SearchTypeCategoryId} from './constants';
import {categoryIdRuleDefaults} from './defaults';
import type {CategoryIdRule, TSearchTypeCategoryId} from './types';
import {validateCatrgoryIdRule} from './validate';
import {getCategoryData} from '@netx/core-category/api/getCategoryData';

export class CategoryIdRuleModel
	extends RuleModel<TSearchTypeCategoryId>
	implements CategoryIdRule
{
	readonly elementType = SearchTypeCategoryId;
	elementSubType1: CategoryType = categoryIdRuleDefaults.elementSubType1;
	elementSubType2: 0 = categoryIdRuleDefaults.elementSubType2;
	elementValue1 = categoryIdRuleDefaults.elementValue1;
	elementValue2: '' = categoryIdRuleDefaults.elementValue2;
	elementValue3: '' = categoryIdRuleDefaults.elementValue3;

	get elementSubType1Options() {
		return enumToValues(CategoryType);
	}

	get isValid() {
		const validation = validateCatrgoryIdRule(this);
		this.setValidationErrors(this.dirty && validation ? validation : undefined);
		if (!validation) return true;
		return false;
	}

	constructor(params?: Partial<Omit<CategoryIdRule, 'elementType'>>) {
		super();

		makeObservable(this, {
			elementSubType1: observable,
			elementSubType1Options: computed,
			elementValue1: observable,
			isValid: computed,
			setElementSubType1: action,
			setElementValue1: action,
		});

		runInAction(() => {
			Object.assign(this, {...categoryIdRuleDefaults, ...params});
		});

		this.reactionDisposers.push(
			autorun(() => {
				this.setElementValue1Unavailable(false);
				this.setElementValue1Loading(true);
				// TODO: make this a service that is passed in
				getCategoryData({id: this.elementValue1})
					.then((category) => this.setElementValue1Label(category.name))
					.catch(() => this.setElementValue1Unavailable(true))
					.finally(() => this.setElementValue1Loading(false));
			}),
		);
	}

	setElementSubType1(elementSubType1: CategoryType) {
		this.elementSubType1 = elementSubType1;
	}

	/** stubbed */
	setElementSubType2() {}

	/**
	 * Set category id
	 * @param elementValue1 category id
	 */
	setElementValue1(elementValue1: number) {
		this.elementValue1 = elementValue1;
	}

	/** stubbed */
	setElementValue2() {}

	/** stubbed */
	setElementValue3() {}
}

export default CategoryIdRuleModel;
